import { SensorPoint } from 'seacube-backend/src/api/client';

import { store } from './store';

export const setSensorData = (sensorData: SensorPoint[]) => {
  store.sensorData.raw = sensorData;
};
export const setSensorDataFiltered = () => {
  if (!store.tsFilterRange || !store.sensorData) return;
  const min = store.tsFilterRange[0];
  const max = store.tsFilterRange[1];
  store.sensorData.filtered = store.sensorData.raw.filter(
    (p) => p.timestamp >= min && p.timestamp <= max,
  );
};

export const setHighlightedSensorDataFiltered = (index: number) => {
  store.sensorData.highlightedIndex = index;
};

export const setShowFuel = (showFuel: boolean) => {
  store.sensorData.showFuel = showFuel;
};
